module.exports = __webpack_public_path__ + "media/images/form-arrow-right-c101f818d055c182e130031d38014e9c.svg";